import { registerFormatter } from '@philips-emr/tws-core/lib/services/model-service';

import CnpjFormatter from './cnpj-formatter';

export * from './overflow-formatter';
export * from './employer-identification-number-formatter';

registerFormatter('cnpj', CnpjFormatter);
